import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';

export const fetchWorkFlowStatusList = async () => {
  const response = await axios.get(`${CM_BASE_URL}/workflow-statuses`);

  if (response.status !== 200) {
    throw { message: 'Failed to fetch statuses' };
  }

  return response.data;
};

export const fetchAlertLevelList = async () => {
  const response = await axios.get(`${CM_BASE_URL}/alertLevelClassification`);

  if (response.status !== 200) {
    throw { message: 'Failed to fetch levels' };
  }

  return response.data;
};

export const updateWorkFlowStatusList = async ({ statusList }) => {
  const url = `${CM_BASE_URL}/workflow-statuses`;

  return axios
    .put(url, statusList)
    .then((res) => {
      if (res.status !== 200) {
        throw new Error(res?.data?.error || 'Failed to update statuses');
      }
      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const updateAlertLevel = async ({ updatedAlertLevels }) => {
  const url = `${CM_BASE_URL}/alertLevelClassification`;

  return axios
    .put(url, updatedAlertLevels)
    .then((res) => {
      if (res.status !== 200) {
        throw new Error(res?.data?.error || 'Failed to update levels');
      }
      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};
